export function getSalesImportErrorMessage(
  error,
  fallback = "No se pudo completar la operación."
) {
  if (error?.name === "AbortError") return fallback;
  if (error?.code === "ERR_NETWORK" || error?.request) {
    return "No pudimos conectar con el servidor. Revisá tu conexión e intentá nuevamente.";
  }

  const message =
    error?.response?.data?.detail ||
    error?.response?.data?.message ||
    error?.data?.detail ||
    error?.data?.message ||
    error?.message;

  return Array.isArray(message) ? message.join(" · ") : message || fallback;
}
